export const FINANCIAL_ENTITIES = {
  projectManagement: 'project-management',
  projects: 'projects',
  engineering: 'engineering',
  leasing: 'leasing',
  permitting: 'permitting',
  accounting: 'accounting',
};
